<template>
    <input @change="valueChanged" v-model='search' />
</template>

<script>
  export default {
    name: 'Search',
    data () {
      return {
        search: ''
      }
    },
    methods: {
      valueChanged () {
        this.$emit('on-value-change', this.search)
      }
    }
  }
</script>

<style lang="scss" scoped>
  input {
      min-width:150px;
  }
</style>